@if (spinner) {
  <div class="spinner">
    <ng-lottie [options]="lottieOptions"></ng-lottie>
  </div>
}
<div class="modal modal--max fade" id="addons-modal" tabindex="-1" role="dialog" aria-labelledby="addons-modal-vehicle"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <header class="modal-addons__header">
        <div class="container-fluid">
          <div class="modal-addons__title">
            <span class="icon icon--md vap-icon">
              <img src="assets/icn/vaps/sm-{{vap.product_vaps_id}}.svg" />
            </span>
            <div class="modal-addons__title-txt">

              <h4 class="vap-name">{{vap?.vaps_name?.length>0?vap.vaps_name:vap.pv[0].vaps_name}}</h4>
              <p class="vap-description">
              {{vap?.vaps_description?.length>0?vap.vaps_description:vap.pv[0].vaps_description}}</p>
            </div>
          </div>
        </div>
        <button class="modal-addons__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-circle-small"></use>
          </svg>
        </button>
      </header>
      <div class="modal-addons__content">
        <div class="modal-addons__content-inner">
          <div class="container-fluid">
            <div class="modal-addons__items">
              @if (question?.cent_aq_question_type_id==72 || question?.cent_aq_question_type_id==83) {
                <div class="modal-addons__item">
                  <div class="form-group">
                    <label>{{question.question_copy}}</label>
                    @for (item of items; track item) {
                      <div class="addon-expander addon-expander--checkbox">
                        <div class="addon-expander__header">
                          <label class="custom-input custom-input--checkbox">
                            <input type="checkbox" [checked]="vap.session_item_id==item.item_id?true:null" id="{{vap.product_vaps_id}}_{{item.item_id}}" (click)="calculate()" />
                            <span class="custom-input__indi"></span>
                          </label>
                          <a href="#addon-vehicle-field" class="addon-expander__title collapsed" data-toggle="collapse"
                            aria-expanded="false">
                            <h6>{{item.data.description_1.split('|')[0]}}</h6>
                            <div class="addon-expander__cost {{item?.price>0?'is-active':''}}">
                              <p><strong class="price addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}</p>
                            </div>
                            <div class="addon-expander__caret"> <svg class="icon"></svg> </div>
                          </a>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (question?.cent_aq_question_type_id==58 || question?.cent_aq_question_type_id==82 || question?.cent_aq_question_type_id==76 ) {
                <div>
                  @for (item of items; track item) {
                    <div class="addon-expander addon-expander--checkbox">
                      <div class="addon-expander__header">
                        <a href="#addon-vehicle-field-{{item.item_id}}" (click)="checkThis(item.item_id)"
                          data-toggle="collapse" aria-expanded="false">
                          <label class="custom-input custom-input--checkbox">
                            <input type="checkbox" id="checkbox_{{vap.product_vaps_id}}_{{item.item_id}}" />
                            <span class="custom-input__indi"></span>
                          </label>
                        </a>
                        <a href="javascript:;" class="addon-expander__title collapsed">
                          <h6>{{item.data.description_1.split('|')[0]}}</h6>
                          <div class="addon-expander__cost">
                            <p>
                              <strong class="price addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}
                            </p>
                          </div>
                          <div class="addon-expander__caret"> <svg class="icon">
                            <use xlink:href="#dropdown"></use>
                          </svg> </div>
                        </a>
                      </div>
                      <div class="addon-expander__content collapse" id="addon-vehicle-field-{{item.item_id}}">
                        <div class="modal-addons__item">
                          <div class="form-group">
                            <label>{{question.question_copy}}</label>
                            <input type="text" id="amount_{{vap.product_vaps_id}}_{{item.item_id}}" value="" prefix="R "
                              mask="separator" (blur)="calculate()" class="form-control answers"
                              placeholder="Max {{accounting.formatMoney(vap.value_max)}}" />
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (question?.cent_aq_question_type_id==81) {
                  <div>
                    @for (item of items; track item) {
                      <div class="addon-expander addon-expander--checkbox">
                        <div class="addon-expander__header">
                          <a href="#addon-vehicle-field-{{item.item_id}}" (click)="checkThis(item.item_id)"
                            data-toggle="collapse" aria-expanded="false">
                            <label class="custom-input custom-input--checkbox">
                              <input type="checkbox" id="checkbox_{{vap.product_vaps_id}}_{{item.item_id}}" />
                              <span class="custom-input__indi"></span>
                            </label>
                          </a>
                          <a href="javascript:;" class="addon-expander__title collapsed">
                            <h6>{{item.data.description_1.split('|')[0]}}</h6>
                            <div class="addon-expander__cost">
                              <p>
                                <strong class="price addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}
                              </p>
                            </div>
                            <div class="addon-expander__caret"> <svg class="icon">
                              <use xlink:href="#dropdown"></use>
                            </svg> </div>
                          </a>
                        </div>
                        <div class="addon-expander__content collapse" id="addon-vehicle-field-{{item.item_id}}">
                          <div class="modal-addons__item">
                            <div class="form-group">
                              <label>{{question.question_copy}}</label>
                              <input type="text" id="amount_{{vap.product_vaps_id}}_{{item.item_id}}" value=""
                                mask="separator" (blur)="calculate()" class="form-control answers"
                                placeholder="Max {{vap.value_max}}" />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (question?.cent_aq_question_type_id==91) {
                    <div>
                      @for (item of items; track item) {
                        <div class="addon-expander addon-expander--checkbox">
                          <div class="addon-expander__header">
                            <a href="#addon-vehicle-field-{{item.item_id}}" (click)="checkThis(item.item_id)"
                              data-toggle="collapse" aria-expanded="false">
                              <label class="custom-input custom-input--checkbox">
                                <input type="checkbox" [checked]="vap.session_item_id==item.item_id?true:null" id="checkbox_{{vap.product_vaps_id}}_{{item.item_id}}" />
                                <span class="custom-input__indi"></span>
                              </label>
                            </a>
                            <a href="javascript:;" class="addon-expander__title collapsed">
                              <h6>{{item.data.description_1.split('|')[0]}}</h6>
                              <div class="addon-expander__cost {{item?.price>0?'is-active':''}}">
                                <p>
                                  <strong class="price addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}
                                </p>
                              </div>
                              <div class="addon-expander__caret"> <svg class="icon">
                                <use xlink:href="#dropdown"></use>
                              </svg> </div>
                            </a>
                          </div>
                          <div class="addon-expander__content collapse" id="addon-vehicle-field-{{item.item_id}}">
                            <div class="modal-addons__item">
                              <div class="form-group">
                                <label>{{question.question_copy}}</label>
                                <input type="text" id="amount_{{vap.product_vaps_id}}_{{item.item_id}}" value="" prefix="R "
                                  mask="separator" (blur)="calculate()" class="form-control answers"
                                  placeholder="Limit {{accounting.formatMoney(vap.value_min)}} - {{accounting.formatMoney(vap.value_max)}}" />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }

                    @if (question?.cent_aq_question_type_id==59) {
                      <div>
                        @for (item of items; track item) {
                          <div class="addon-expander addon-expander--checkbox">
                            <div class="addon-expander__header">
                              <a href="#addon-vehicle-field-{{item.item_id}}" (click)="checkThis(item.item_id)"
                                data-toggle="collapse" aria-expanded="false">
                                <label class="custom-input custom-input--checkbox">
                                  <input type="checkbox" id="checkbox_{{vap.product_vaps_id}}_{{item.item_id}}" />
                                  <span class="custom-input__indi"></span>
                                </label>
                              </a>
                              <a href="javascript:;" class="addon-expander__title collapsed">
                                <h6>{{item.data.description_1.split('|')[0]}}</h6>
                                <div class="addon-expander__cost">
                                  <p>
                                    <strong class="price addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}
                                  </p>
                                </div>
                                <div class="addon-expander__caret"> <svg class="icon">
                                  <use xlink:href="#dropdown"></use>
                                </svg> </div>
                              </a>
                            </div>
                            <div class="addon-expander__content collapse" id="addon-vehicle-field-{{item.item_id}}">
                              <div class="modal-addons__item">
                                <div class="form-group">
                                  <label>{{question.question_copy}}</label>
                                  <input type="text" id="percent_{{vap.product_vaps_id}}_{{item.item_id}}" value="" suffix="%"
                                    mask="percent" (blur)="calculate()" class="form-control answers"
                                    placeholder="Max {{vap.value_max}}%" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }

                      @if (question?.cent_aq_question_type_id==70) {
                        <div class="modal-addons__item">
                          <div class="form-group">
                            <label>{{question.question_copy}}</label>
                            <select id="dropdown-{{question.cent_aq_question_id}}" class="ui-selectmenu">
                              <option>Please Select</option>
                              @for (option of options; track trackByFn(i, option); let i = $index) {
                                <option value="{{option.rate_id}}">
                                  {{option.rate_name}}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      }
                      @if (question?.cent_aq_question_type_id==65) {
                        <div class="modal-addons__item">
                          <div class="form-group">
                            <label>{{question.question_copy}}</label>
                            <input type="text" id="amount" value="" prefix="R "
                              mask="separator" (blur)="calculate()" class="form-control answers"
                              placeholder="Limit {{accounting.formatMoney(vap.value_min)}} - {{accounting.formatMoney(vap.value_max)}}" />
                            </div>
                          </div>
                        }
                        @if (question?.cent_aq_question_type_id==67) {
                          <div>
                            @for (item of items; track item) {
                              <div class="addon-expander">
                                <div class="addon-expander__header">
                                  <a href="#addon-general-field-{{item.item_id}}" class="addon-expander__title {{item.item_id}}" data-toggle="collapse"
                                    aria-expanded="true">
                                    @if (item.data.description_1) {
                                      <h6>{{item?.data?.description_1}}</h6>
                                    }
                                    @if (!item.data.description_1) {
                                      <h6>Add Cover</h6>
                                    }
                                    <div class="addon-expander__cost {{item?.price>0?'is-active':''}}">
                                      <p><strong class="addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}</p>
                                    </div>
                                    <div class="addon-expander__caret">
                                      <svg class="icon">
                                        <use xlink:href="#dropdown"></use>
                                      </svg>
                                    </div>
                                  </a>
                                </div>
                                <div class="addon-expander__content collapse show" id="addon-general-field-{{item.item_id}}">
                                  <div class="modal-addons__item">
                                    <div class="form-group">
                                      <label>{{question.question_copy}}</label>
                                      <input type="text" value="" (blur)="calculate()"  class="form-control name answers {{item.item_id}}" placeholder="Name" />
                                    </div>
                                    <div class="form-group">
                                      <input type="text" value="" (blur)="calculate()"  class="form-control surname answers {{item.item_id}}" placeholder="Surname" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (question?.cent_aq_question_type_id==84) {
                          <div>
                            @for (item of items; track item) {
                              <div class="addon-expander">
                                <div class="addon-expander__header">
                                  <a href="#addon-general-field-{{item.item_id}}" class="addon-expander__title {{item.item_id}}" data-toggle="collapse"
                                    aria-expanded="true">
                                    @if (item.data.description_1) {
                                      <h6>{{item?.data?.description_1}}</h6>
                                    }
                                    @if (!item.data.description_1) {
                                      <h6>Add Cover</h6>
                                    }
                                    <div class="addon-expander__cost {{item?.price>0?'is-active':''}}">
                                      <p><strong class="addon-price">{{accounting.formatMoney(item?.price)}}</strong> /{{policy?.frequency_short}}</p>
                                    </div>
                                    <div class="addon-expander__caret">
                                      <svg class="icon">
                                        <use xlink:href="#dropdown"></use>
                                      </svg>
                                    </div>
                                  </a>
                                </div>
                                <div class="addon-expander__content collapse show" id="addon-general-field-{{item.item_id}}">
                                  <div class="modal-addons__item">
                                    <div class="form-group">
                                      <label>{{question.question_copy}}</label>
                                      <input type="text" value="" (blur)="calculate()"  class="form-control name answers {{item.item_id}}" placeholder="Name" />
                                    </div>
                                    <div class="form-group">
                                      <input type="text" value="" (blur)="calculate()"  class="form-control surname answers {{item.item_id}}" placeholder="Surname" />
                                    </div>
                                    <div class="form-group">
                                      <!-- {{"0832718926" | mask: '(000) 000-0000'}} -->
                                      <input type="tel" value="" prefix="R " mask="separator" (blur)="calculate()"  class="form-control amount answers {{item.item_id}}" placeholder="Amount" />
                                    </div>
                                    <div class="form-group">
                                      <select id="dropdown-{{item.item_id}}" class="ui-selectmenu">
                                        <option value="">Please Select</option>
                                        @for (option of options; track trackByFn(i, option); let i = $index) {
                                          <option value="{{option.rate_id}}">
                                            {{option.rate_name}}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (question?.cent_aq_question_type_id==68) {
                          <div>
                            <div class="modal-addons__item">
                              <div class="form-group">
                                <label>{{question.question_copy}}</label>
                                <input type="text" value="" (blur)="calculate()" class="form-control name answers"
                                  placeholder="Name" />
                                </div>
                                <div class="form-group">
                                  <input type="text" value="" (blur)="calculate()"
                                    class="form-control surname answers" placeholder="Surname" />
                                  </div>
                                  <div class="form-group">
                                    <!-- {{"0832718926" | mask: '(000) 000-0000'}} -->
                                    <input type="tel" value="" prefix="R " mask="separator" (blur)="calculate()"
                                      class="form-control amount answers" placeholder="Limit {{accounting.formatMoney(vap.value_min)}} - {{accounting.formatMoney(vap.value_max)}}" />
                                    </div>
                                  </div>
                                </div>
                              }
                              @if (question?.cent_aq_question_type_id==85) {
                                <div>
                                  <div class="modal-addons__item">
                                    <div class="form-group">
                                      <label>{{question.question_copy}}</label>
                                      <input type="text" value="" (blur)="calculate()" class="form-control description answers"
                                        placeholder="Description" />
                                      </div>
                                      <div class="form-group">
                                        <input type="tel" value="" prefix="R " mask="separator" (blur)="calculate()"
                                          class="form-control amount answers" placeholder="Limit {{accounting.formatMoney(vap.value_min)}} - {{accounting.formatMoney(vap.value_max)}}" />
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                                @if (question?.add_another==1) {
                                  <div class="modal-addons__add">
                                    <div class="button-control" (click)="addAnother(question?.cent_aq_question_type_id)">
                                      <svg class="icon icon--sm"><use xlink:href="#plus"></use></svg><strong>Add Another</strong>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>

                          <div class="modal-addons__btn">
                            <div class="container-fluid">
                              <div class="modal-addons__btn-inner">
                                <a href="javascript:;" (click)="addItem()" [attr.disabled]="valid?null:''" class="button button--primary button--lg btn-addon-add addon-total">{{button}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
